import { observer } from 'mobx-react-lite';
import ReadOnlyTruncatedRecipientWell from 'owa-readonly-recipient-well/lib/components/ReadOnlyTruncatedRecipientWell';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import mergeReadWriteRecipientWellIntoReadOnly from '../utils/mergeReadWriteRecipientWellIntoReadOnly';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';
import * as React from 'react';

const styles = require('./CompactRecipientWell.scss');
const classNames = require('classnames');

export interface CompactRecipientWellProps {
    toRecipientWell: RecipientWellWithFindControlViewState;
    recipientType: RecipientType;
    ccRecipientWell?: RecipientWellWithFindControlViewState;
    onSwitchToReadWriteWell: () => void;
    className?: string;
}

const CompactRecipientWell = observer((props: CompactRecipientWellProps) => {
    const allRecipients = [];
    mergeReadWriteRecipientWellIntoReadOnly(props.toRecipientWell, allRecipients);
    mergeReadWriteRecipientWellIntoReadOnly(props.ccRecipientWell, allRecipients);

    return (
        <div
            key="compactRecipientWellDiv"
            className={classNames(styles.compactRecipientRow, props.className)}
            onFocus={props.onSwitchToReadWriteWell}
            tabIndex={0}>
            <ReadOnlyTruncatedRecipientWell
                recipientType={props.recipientType}
                recipients={allRecipients}
                totalRecipientCount={allRecipients.length}
                onToggleIsTruncated={props.onSwitchToReadWriteWell}
                disableHover={true}
            />
        </div>
    );
});

export default CompactRecipientWell;
